<template>
  <div id="program">
    <app-menu></app-menu>
    <admin-list-component
        :title="'Admin.menu.year' | staticTranslation"
        :add-text="'Admin.components.addYear' | staticTranslation"
        edit-path="/admin/program/period/edit/"
        entity-name="period"
        :get-name-function="getName"
        draggable="true"
    />
  </div>
</template>

<script>
import AdminMenu from "@/components/admin/AdminMenu";
import AdminListComponent from "@/components/admin/AdminListComponent";

export default {
  name: "program",
  components: {
    'app-menu': AdminMenu,
    'admin-list-component': AdminListComponent
  },
  data() {
    return {
      periods: []
    }
  },
  methods: {
    getName: function (period) {
      return period.name;
    }
  }
}
</script>

<style scoped>
#program {
  background-color: white;
  height: 100vh;
  overflow: hidden;
}
</style>
